import styled from 'styled-components'

export const Wrapper = styled.div<{ isSticky?: boolean; isTop?: boolean }>`
  background-color: ${p => p.theme.colors.white[1]};
  box-shadow: ${p => (p.isTop ? 'none' : p.theme.shadows.menuOpen)};
  position: sticky;
  top: 0;
  transition: box-shadow 0.35s, transform 0.35s;
  transform: ${p => (p.isSticky ? 'translateY(calc(var(--nav-height) * -1))' : 'translateY(0px)')};
  z-index: 100;
  border-bottom: 1px solid ${p => p.theme.colors.black[6]};
`
